import { request } from "../libs/http/http"



export const downloadPDF = (ot) =>{
    const {numeroOrden, visitas, otType} = ot
    return request('post',`/Ot/pdf?numeroOrden=${numeroOrden}&visitas=${parseInt(visitas)}&otType=${otType}`,{},{'Accept':'*/*'})
}